import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, User, MapPin } from 'lucide-react';
import { apiClient } from '../api';

const PicksCarousel = () => {
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    apiClient.get('/picks/today')
      .then((r) => { if (mounted) setPicks(r.data || []); })
      .catch(() => {})
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  if (loading) return null;
  if (!picks || picks.length === 0) return null;

  return (
    <section className="mb-8" data-testid="picks-carousel">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-5 h-5 text-fnl-pink" />
        <h2 className="text-xl font-bold text-white">Picked for you today</h2>
        <span className="text-purple-300 text-xs ml-1">Curated based on your interests</span>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-3 -mx-1 px-1 snap-x" data-testid="picks-scroller">
        {picks.map((p) => (
          <Link
            to={`/profile/${p.user_id}`}
            key={p.user_id}
            data-testid={`pick-${p.user_id}`}
            className="snap-start shrink-0 w-44 sm:w-52 group bg-fnl-purple/60 rounded-2xl overflow-hidden border border-fnl-pink/30 hover:border-fnl-pink/70 transition-colors shadow-lg shadow-fnl-pink/5"
          >
            <div className="aspect-[3/4] relative bg-fnl-purple-light overflow-hidden">
              {p.photo_base64 ? (
                <img src={p.photo_base64} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <User className="w-14 h-14 text-fnl-pink/50" />
                </div>
              )}
              <div className="absolute top-2 right-2 bg-fnl-pink/95 text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full flex items-center gap-1">
                <Sparkles className="w-3 h-3" />Top match
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-fnl-dark via-transparent to-transparent" />
              <div className="absolute bottom-2 left-2 right-2 text-white">
                <div className="font-bold leading-tight">{p.name}, {p.age}</div>
                {p.location && (
                  <div className="text-[10px] text-purple-200 flex items-center gap-0.5 mt-0.5 truncate">
                    <MapPin className="w-2.5 h-2.5" />{p.location}
                  </div>
                )}
              </div>
            </div>
            {p.shared_interests && p.shared_interests.length > 0 && (
              <div className="p-2 flex flex-wrap gap-1">
                {p.shared_interests.map((i) => (
                  <span key={i} className="text-[10px] px-2 py-0.5 rounded-full bg-fnl-pink/15 text-fnl-pink border border-fnl-pink/30">
                    {i}
                  </span>
                ))}
              </div>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PicksCarousel;
